import { callAPI } from '../network';

export async function getAreas (companyId){
  
   const data = await callAPI(
                        null, 
                        'Area/GetAllAreas?companyId=' + companyId, 'get');
   return data || [ ];
}

export async function getArea (id){

    const data = await callAPI(
                         null, 
                         'Area/GetAreaById?id='+ id, 'get');
    return data;
 }

 export async function saveArea (customer){
   
   
   const data = await callAPI(
                        customer, 
                        'Area/InsertArea', 'post');
   return data;
}

export async function updateArea (customer){
   
   const data = await callAPI(
                        customer, 
                        'Area/UpdateArea', 'post');
   return data;
}

export async function deleteArea (id){
   const data = await callAPI(
                        null,
                        'Area/DeleteArea?id='+ id, 'get');
   return data;
}

export async function findNewsletterByTypeId (typeId){
   const data = await callAPI(
                        null, 
                        'Area/GetNewsletterByTypeId?typeId='+ typeId, 'get');
   return data;
}